import { ChainDataList } from "../helpers";

export const CHAIN_DATA_LIST: ChainDataList = {
  1: {
    chainId: 1,
    chain: "ETH",
    network: "mainnet",
    networkId: 1
  },
  2: {
    chainId: 2,
    chain: "EXP",
    network: "mainnet",
    networkId: 1
  },
  3: {
    chainId: 3,
    chain: "ETH",
    network: "ropsten",
    networkId: 3
  },
  4: {
    chainId: 4,
    chain: "ETH",
    network: "rinkeby",
    networkId: 4
  },
  5: {
    chainId: 5,
    chain: "ETH",
    network: "goerli",
    networkId: 5
  },
  6: {
    chainId: 6,
    chain: "ETC",
    network: "kotti",
    networkId: 6
  },
  8: {
    chainId: 8,
    chain: "UBQ",
    network: "mainnet",
    networkId: 88
  },
  9: {
    chainId: 9,
    chain: "UBQ",
    network: "mainnet",
    networkId: 2
  },
  11: {
    chainId: 11,
    chain: "META",
    network: "mainnet",
    networkId: 11
  },
  12: {
    chainId: 12,
    chain: "META",
    network: "testnet",
    networkId: 12
  },
  18: {
    chainId: 18,
    chain: "TST",
    network: "testnet",
    networkId: 18
  },
  30: {
    chainId: 30,
    chain: "RSK",
    network: "mainnet",
    networkId: 30
  },
  31: {
    chainId: 31,
    chain: "RSK",
    network: "testnet",
    networkId: 31
  },
  42: {
    chainId: 42,
    chain: "ETH",
    network: "kovan",
    networkId: 42
  },
  60: {
    chainId: 60,
    chain: "GO",
    network: "mainnet",
    networkId: 60
  },
  61: {
    chainId: 61,
    chain: "ETC",
    network: "mainnet",
    networkId: 1
  },
  62: {
    chainId: 62,
    chain: "ETC",
    network: "testnet",
    networkId: 2
  },
  63: {
    chainId: 63,
    chain: "ETC",
    network: "testnet",
    networkId: 7
  },
  64: {
    chainId: 64,
    chain: "ELLA",
    network: "mainnet",
    networkId: 64
  },
  76: {
    chainId: 76,
    chain: "MIX",
    network: "mainnet",
    networkId: 76
  },
  77: {
    chainId: 77,
    chain: "POA",
    network: "sokol",
    networkId: 77
  },
  88: {
    chainId: 88,
    chain: "TOMO",
    network: "mainnet",
    networkId: 88
  },
  99: {
    chainId: 99,
    chain: "POA",
    network: "core",
    networkId: 99
  },
  100: {
    chainId: 100,
    chain: "XDAI",
    network: "mainnet",
    networkId: 100
  },
  101: {
    chainId: 101,
    chain: "ETI",
    network: "mainnet",
    networkId: 1
  },
  108: {
    chainId: 108,
    chain: "TT",
    network: "mainnet",
    networkId: 108
  },
  162: {
    chainId: 162,
    chain: "PHT",
    network: "sirius",
    networkId: 162
  },
  163: {
    chainId: 163,
    chain: "PHT",
    network: "mainnet",
    networkId: 163
  },
  211: {
    chainId: 211,
    chain: "FTN",
    network: "freight",
    networkId: 0
  },
  269: {
    chainId: 269,
    chain: "HPB",
    network: "mainnet",
    networkId: 100
  },
  385: {
    chainId: 385,
    chain: "CRO",
    network: "mainnet",
    networkId: 385
  },
  820: {
    chainId: 820,
    chain: "CLO",
    network: "mainnet",
    networkId: 1
  },
  821: {
    chainId: 821,
    chain: "CLO",
    network: "testnet",
    networkId: 2
  }
};
